module.exports = __webpack_public_path__ + "static/media/portfolio-1.09033525.jpg";